module.exports = __webpack_public_path__ + "assets/img/Grand.6b993430.svg";